import { Subject } from 'rxjs/Subject';
var Url = (function () {
    function Url(protocol, baseUrl, endPoint) {
        this.protocol = protocol;
        this.baseUrl = baseUrl;
        this.endPoint = endPoint;
    }
    Object.defineProperty(Url.prototype, "url", {
        get: function () {
            return this.protocol + "://" + this.baseUrl + this.endPoint;
        },
        enumerable: true,
        configurable: true
    });
    Url.prototype.getHttpUrl = function () {
        return new Url(this.protocol === 'ws' ? 'http' : 'https', this.baseUrl, this.endPoint);
    };
    Url.prototype.getUrlWith = function (queryParameters) {
        var buffer = '';
        // tslint:disable-next-line:forin
        for (var propt in queryParameters) {
            if (buffer.length > 0) {
                buffer += '&';
            }
            buffer += propt + '=' + encodeURIComponent(queryParameters[propt]);
        }
        return this.url + (queryParameters ? '?' + buffer : '');
    };
    return Url;
}());
export { Url };
var Protocol = (function () {
    function Protocol(loggerService, protocolConfig) {
        this.loggerService = loggerService;
        this.protocolConfig = protocolConfig;
        this._open = new Subject();
        this._close = new Subject();
        this._message = new Subject();
        this._error = new Subject();
        if (!protocolConfig) {
            this.protocolConfig = {
                initialTimeout: 500,
                maxTimeout: 300000,
            };
        }
    }
    Protocol.prototype.message$ = function () {
        return this._message.asObservable();
    };
    Protocol.prototype.open$ = function () {
        return this._open.asObservable();
    };
    Protocol.prototype.close$ = function () {
        return this._close.asObservable();
    };
    Protocol.prototype.error$ = function () {
        return this._error.asObservable();
    };
    Protocol.prototype.reconnect = function () {
        this.destroy();
        setTimeout(this.start(), 0);
    };
    // Exponential Backoff Formula by Prof. Douglas Thain
    // http://dthain.blogspot.co.uk/2009/02/exponential-backoff-in-distributed.html
    Protocol.prototype.getBackoffDelay = function (attempt) {
        if (this.protocolConfig && !this.protocolConfig.timeWaitToReconnect) {
            var R = Math.random() + 1;
            var T = this.protocolConfig.initialTimeout;
            var F = 2;
            var N = attempt;
            var M = this.protocolConfig.maxTimeout;
            return Math.floor(Math.min(R * T * Math.pow(F, N), M));
        }
        else {
            return this.protocolConfig.timeWaitToReconnect;
        }
    };
    return Protocol;
}());
export { Protocol };
//# sourceMappingURL=protocol.js.map